import { createSlice } from "@reduxjs/toolkit";

const order = createSlice({
  name: "orders",
  initialState: {
    data: [],
  },
  reducers: {
    getOrders(state, action) {
      state.data = action.payload;
      state.loading = false;
    },

  },
});

export const { getOrders } = order.actions;
export default order.reducer;
